"use strict";

var _createForOfIteratorHelper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@netgum/utils");

var bn_js_1 = __importDefault(require("bn.js"));

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var constants_1 = require("./constants");

var errors_1 = require("./errors");

var modules_1 = require("./modules");

var SdkError_1 = require("./SdkError");
/**
 * Sdk
 */


var Sdk = /*#__PURE__*/function () {
  /**
   * constructor
   * @param environment
   */
  function Sdk(environment) {
    _classCallCheck(this, Sdk);

    this.environment = environment;
    this.state = new modules_1.State();
    this.error$ = new rxjs_1.BehaviorSubject(null);
    this.event$ = new rxjs_1.BehaviorSubject(null);
    this.subscriptions = null;
    this.catchError = this.catchError.bind(this);

    try {
      SdkError_1.SdkError.attachTo(Object.getOwnPropertyNames(Sdk.prototype), this);
      this.setEnvironment(environment);
    } catch (err) {
      SdkError_1.SdkError.throwFromAny(err);
    }
  }
  /**
   * initializes sdk
   * @param options
   */


  _createClass(Sdk, [{
    key: "initialize",
    value: function initialize() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$state, initialized$, initialized;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.require({
                  initialized: null,
                  accountConnected: null
                });

                try {
                  options = {
                    device: options.device || {},
                    environment: options.environment || null
                  };
                } catch (err) {
                  options = {
                    device: {},
                    environment: null
                  };
                }

                _this$state = this.state, initialized$ = _this$state.initialized$, initialized = _this$state.initialized;

                if (initialized !== null) {
                  this.clearSubscriptions();
                  this.state.reset();
                  initialized$.next(null);
                }

                _context.prev = 4;
                this.setEnvironment(options.environment || this.environment);
                _context.next = 8;
                return this.device.setup(options.device || {});

              case 8:
                _context.t0 = this.addSubscriptions;
                _context.t1 = this;
                _context.t2 = [this.action.setup()];
                _context.t3 = _toConsumableArray(this.url.setup());
                _context.t4 = _toConsumableArray;
                _context.next = 15;
                return this.state.setup(this.storage);

              case 15:
                _context.t5 = _context.sent;
                _context.t6 = (0, _context.t4)(_context.t5);
                _context.t7 = [this.action.$incoming.subscribe(this.state.incomingAction$)];
                _context.t8 = _context.t2.concat.call(_context.t2, _context.t3, _context.t6, _context.t7);

                _context.t0.apply.call(_context.t0, _context.t1, _context.t8);

                _context.next = 22;
                return this.session.setup();

              case 22:
                if (!this.state.account) {
                  _context.next = 25;
                  break;
                }

                _context.next = 25;
                return this.verifyAccount();

              case 25:
                initialized$.next(true);
                this.subscribeAccountBalance();
                this.subscribeApiEvents();
                this.subscribeAcceptedActions();
                _context.next = 35;
                break;

              case 31:
                _context.prev = 31;
                _context.t9 = _context["catch"](4);
                initialized$.next(false);
                SdkError_1.SdkError.throwFromAny(_context.t9);

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 31]]);
      }));
    }
    /**
     * resets sdk
     * @param options
     */

  }, {
    key: "reset",
    value: function reset() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$state2, accountAddress, accountFriendRecovery$;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                try {
                  options = {
                    device: !!options.device,
                    session: !!options.session
                  };
                } catch (err) {
                  options = {
                    device: false,
                    session: false
                  };
                }

                _this$state2 = this.state, accountAddress = _this$state2.accountAddress, accountFriendRecovery$ = _this$state2.accountFriendRecovery$;

                if (!accountAddress) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 6;
                return this.disconnectAccount();

              case 6:
                if (!options.device) {
                  _context2.next = 10;
                  break;
                }

                accountFriendRecovery$.next(null);
                _context2.next = 10;
                return this.device.reset();

              case 10:
                if (!options.session) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 13;
                return this.session.reset({
                  token: true
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    } // Account

    /**
     * gets connected accounts
     * @param page
     */

  }, {
    key: "getConnectedAccounts",
    value: function getConnectedAccounts() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                return _context3.abrupt("return", this.apiMethods.getConnectedAccounts(page));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * searches account
     * @param address
     * @param ensName
     */

  }, {
    key: "searchAccount",
    value: function searchAccount(_ref) {
      var address = _ref.address,
          ensName = _ref.ensName;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.require({
                  initialized: null,
                  accountConnected: null
                });

                result = null;
                _context4.prev = 2;

                if (!address) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 6;
                return this.apiMethods.getAccount(address);

              case 6:
                result = _context4.sent;
                _context4.next = 13;
                break;

              case 9:
                if (!ensName) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 12;
                return this.apiMethods.searchAccount(ensName);

              case 12:
                result = _context4.sent;

              case 13:
                _context4.next = 18;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](2);
                result = null;

              case 18:
                if (!result) {
                  _context4.next = 22;
                  break;
                }

                _context4.next = 21;
                return this.prepareAccount(result);

              case 21:
                result = _context4.sent;

              case 22:
                return _context4.abrupt("return", result);

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 15]]);
      }));
    }
    /**
     * creates account
     * @param ensLabel
     * @param ensRootName
     */

  }, {
    key: "createAccount",
    value: function createAccount(ensLabel, ensRootName) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var account;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.require({
                  accountConnected: false
                });

                _context5.next = 3;
                return this.apiMethods.createAccount(this.ens.buildName(ensLabel, ensRootName));

              case 3:
                account = _context5.sent;
                _context5.t0 = this.state.account$;
                _context5.next = 7;
                return this.prepareAccount(account);

              case 7:
                _context5.t1 = _context5.sent;

                _context5.t0.next.call(_context5.t0, _context5.t1);

                _context5.next = 11;
                return this.verifyAccount();

              case 11:
                return _context5.abrupt("return", this.state.account);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * connects account
     * @param accountAddress
     */

  }, {
    key: "connectAccount",
    value: function connectAccount(accountAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.disconnectAccount();

              case 2:
                _context6.next = 4;
                return this.verifyAccount(accountAddress);

              case 4:
                return _context6.abrupt("return", this.state.account);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /**
     * disconnects account
     */

  }, {
    key: "disconnectAccount",
    value: function disconnectAccount() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this$state3, account$, accountDevice$;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                _this$state3 = this.state, account$ = _this$state3.account$, accountDevice$ = _this$state3.accountDevice$;
                account$.next(null);
                accountDevice$.next(null);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     * updates account
     * @param ensLabel
     * @param ensRootName
     */

  }, {
    key: "updateAccount",
    value: function updateAccount(ensLabel, ensRootName) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var accountAddress, account;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.require({
                  accountCreated: true,
                  accountDeviceOwner: true
                });

                accountAddress = this.state.accountAddress;
                _context8.next = 4;
                return this.apiMethods.updateAccountEnsName(accountAddress, this.ens.buildName(ensLabel, ensRootName));

              case 4:
                account = _context8.sent;
                this.state.account$.next(account);
                return _context8.abrupt("return", this.state.account);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
    /**
     * estimates account deployment
     * @param gasPriceStrategy
     */

  }, {
    key: "estimateAccountDeployment",
    value: function estimateAccountDeployment() {
      var gasPriceStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : constants_1.GasPriceStrategies.Avg;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.require({
                  accountCreated: true,
                  accountDeviceOwner: true
                });

                accountAddress = this.state.accountAddress;
                return _context9.abrupt("return", this.apiMethods.estimateAccountDeployment(accountAddress, gasPriceStrategy));

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
    /**
     * deploys account
     * @param estimated
     */

  }, {
    key: "deployAccount",
    value: function deployAccount(estimated) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var accountAddress, gasPrice, guardianSignature;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.require({
                  accountCreated: true,
                  accountDeviceOwner: true,
                  accountRealBalance: estimated.totalCost
                });

                accountAddress = this.state.accountAddress;
                gasPrice = estimated.gasPrice, guardianSignature = estimated.guardianSignature;
                return _context10.abrupt("return", this.apiMethods.deployAccount(accountAddress, gasPrice, guardianSignature).catch(function () {
                  return SdkError_1.SdkError.throwEthTransactionReverted();
                }));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    } // Account Virtual Balance

    /**
     * estimates top-up account virtual balance
     * @param value
     * @param tokenAddress
     * @param gasPriceStrategy
     */

  }, {
    key: "estimateTopUpAccountVirtualBalance",
    value: function estimateTopUpAccountVirtualBalance(value) {
      var tokenAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var gasPriceStrategy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : constants_1.GasPriceStrategies.Avg;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this$contract, virtualPaymentManager, erc20Token, result, data1, data2;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                _this$contract = this.contract, virtualPaymentManager = _this$contract.virtualPaymentManager, erc20Token = _this$contract.erc20Token;

                if (!tokenAddress) {
                  _context11.next = 10;
                  break;
                }

                data1 = erc20Token.encodeMethodInput('approve', virtualPaymentManager.address, utils_1.anyToBN(value, {
                  defaults: new bn_js_1.default(0)
                }));
                data2 = virtualPaymentManager.encodeMethodInput('depositToken', tokenAddress, utils_1.anyToBN(value, {
                  defaults: new bn_js_1.default(0)
                }));
                _context11.next = 7;
                return this.estimateAccountTransaction(tokenAddress, 0, data1, virtualPaymentManager.address, 0, data2, gasPriceStrategy);

              case 7:
                result = _context11.sent;
                _context11.next = 13;
                break;

              case 10:
                _context11.next = 12;
                return this.estimateAccountTransaction(virtualPaymentManager.address, value, Buffer.alloc(0), gasPriceStrategy);

              case 12:
                result = _context11.sent;

              case 13:
                return _context11.abrupt("return", result);

              case 14:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
    /**
     * estimates withdraw from account virtual balance
     * @param value
     * @param tokenAddress
     * @param gasPriceStrategy
     */

  }, {
    key: "estimateWithdrawFromAccountVirtualBalance",
    value: function estimateWithdrawFromAccountVirtualBalance(value) {
      var tokenAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var gasPriceStrategy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : constants_1.GasPriceStrategies.Avg;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var accountAddress, payment, _yield$this$accountPa, hash;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                accountAddress = this.state.accountAddress;
                _context12.next = 4;
                return this.createAccountPayment(accountAddress, tokenAddress, value);

              case 4:
                payment = _context12.sent;
                _context12.next = 7;
                return this.accountPayment.signAccountPayment(payment);

              case 7:
                _yield$this$accountPa = _context12.sent;
                hash = _yield$this$accountPa.hash;
                return _context12.abrupt("return", this.estimateWithdrawAccountPayment(hash, gasPriceStrategy));

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
    /**
     * gets connected account virtual balances
     * @param page
     */

  }, {
    key: "getConnectedAccountVirtualBalances",
    value: function getConnectedAccountVirtualBalances() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context13.abrupt("return", this.apiMethods.getAccountVirtualBalances(accountAddress, page));

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
    /**
     * gets connected account virtual balance
     * @param symbolOrAddress
     */

  }, {
    key: "getConnectedAccountVirtualBalance",
    value: function getConnectedAccountVirtualBalance(symbolOrAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context14.abrupt("return", this.apiMethods.getAccountVirtualBalance(accountAddress, symbolOrAddress));

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
    /**
     * gets connected account virtual pending balances
     */

  }, {
    key: "getConnectedAccountVirtualPendingBalances",
    value: function getConnectedAccountVirtualPendingBalances() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context15.abrupt("return", this.apiMethods.getAccountVirtualPendingBalances(accountAddress));

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
    /**
     * gets connected account virtual pending balance
     * @param symbolOrAddress
     */

  }, {
    key: "getConnectedAccountVirtualPendingBalance",
    value: function getConnectedAccountVirtualPendingBalance(symbolOrAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context16.abrupt("return", this.apiMethods.getAccountVirtualPendingBalance(accountAddress, symbolOrAddress));

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    } // Account Friend Recovery

    /**
     * estimates add account friend recovery extension
     * @param gasPriceStrategy
     */

  }, {
    key: "estimateAddAccountFriendRecoveryExtension",
    value: function estimateAddAccountFriendRecoveryExtension() {
      var gasPriceStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : constants_1.GasPriceStrategies.Avg;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var accountAddress, account, accountFriendRecovery, extensionDevice, data;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                accountAddress = this.state.accountAddress;
                account = this.contract.account;
                accountFriendRecovery = this.contract.accountFriendRecovery;
                _context17.next = 6;
                return this.getConnectedAccountDevice(accountFriendRecovery.address).catch(function () {
                  return null;
                });

              case 6:
                extensionDevice = _context17.sent;

                if (extensionDevice) {
                  _context17.next = 11;
                  break;
                }

                _context17.next = 10;
                return this.apiMethods.createAccountDevice(accountAddress, accountFriendRecovery.address, constants_1.AccountDeviceTypes.Extension);

              case 10:
                extensionDevice = _context17.sent;

              case 11:
                if (!extensionDevice.nextState) {
                  _context17.next = 13;
                  break;
                }

                throw errors_1.ERR_ADDING_EXTENSION_IN_PROGRESS;

              case 13:
                if (!(extensionDevice.state === constants_1.AccountDeviceStates.Deployed)) {
                  _context17.next = 15;
                  break;
                }

                throw errors_1.ERR_EXTENSION_ALREADY_ADDED;

              case 15:
                data = account.encodeMethodInput('addDevice', accountFriendRecovery.address, true);
                return _context17.abrupt("return", this.apiMethods.estimateAccountProxyTransaction(accountAddress, data, gasPriceStrategy));

              case 17:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
    /**
     * estimates setup account friend recovery extension
     * @param requiredFriends
     * @param friendAddresses
     * @param gasPriceStrategy
     */

  }, {
    key: "estimateSetupAccountFriendRecoveryExtension",
    value: function estimateSetupAccountFriendRecoveryExtension(requiredFriends, friendAddresses) {
      var gasPriceStrategy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : constants_1.GasPriceStrategies.Avg;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var accountFriendRecovery, extensionDevice, data;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                accountFriendRecovery = this.contract.accountFriendRecovery;
                _context18.next = 4;
                return this.getConnectedAccountDevice(accountFriendRecovery.address).catch(function () {
                  return null;
                });

              case 4:
                extensionDevice = _context18.sent;

                if (extensionDevice) {
                  _context18.next = 7;
                  break;
                }

                throw errors_1.ERR_EXTENSION_NOT_ADDED;

              case 7:
                if (!(extensionDevice.state !== constants_1.AccountDeviceStates.Deployed)) {
                  _context18.next = 9;
                  break;
                }

                throw errors_1.ERR_ADDING_EXTENSION_IN_PROGRESS;

              case 9:
                data = accountFriendRecovery.encodeMethodInput('setup', requiredFriends, friendAddresses);
                return _context18.abrupt("return", this.estimateAccountTransaction(accountFriendRecovery.address, 0, data, gasPriceStrategy));

              case 11:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
    /**
     * gets connected account friend recovery extension
     */

  }, {
    key: "getConnectedAccountFriendRecoveryExtension",
    value: function getConnectedAccountFriendRecoveryExtension() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var accountFriendRecovery;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                this.require();

                accountFriendRecovery = this.contract.accountFriendRecovery;
                return _context19.abrupt("return", this.getConnectedAccountDevice(accountFriendRecovery.address).catch(function () {
                  return null;
                }));

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
    /**
     * gets connected account friend recovery
     */

  }, {
    key: "getConnectedAccountFriendRecovery",
    value: function getConnectedAccountFriendRecovery() {
      this.require();

      var accountAddress = this.state.accountAddress;
      return this.apiMethods.getAccountFriendRecovery(accountAddress);
    }
    /**
     * gets account friend recovery
     * @param accountAddress
     */

  }, {
    key: "getAccountFriendRecovery",
    value: function getAccountFriendRecovery(accountAddress) {
      this.require({
        accountConnected: null
      });

      return this.apiMethods.getAccountFriendRecovery(accountAddress);
    }
    /**
     * starts account friend recovery
     * @param accountAddress
     */

  }, {
    key: "startAccountFriendRecovery",
    value: function startAccountFriendRecovery(accountAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                _context20.next = 3;
                return this.accountFriendRecovery.startAccountFriendRecovery(accountAddress);

              case 3:
                return _context20.abrupt("return", this.state.accountFriendRecovery);

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
    }
    /**
     * collects account friend signature
     * @param friendAddress
     * @param friendSignature
     */

  }, {
    key: "collectAccountFriendSignature",
    value: function collectAccountFriendSignature(friendAddress, friendSignature) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                _context21.next = 3;
                return this.accountFriendRecovery.collectAccountFriendSignature(friendAddress, friendSignature);

              case 3:
                return _context21.abrupt("return", this.state.accountFriendRecovery);

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
    /**
     * signs account friend recovery
     * @param accountAddress
     * @param deviceAddress
     * @param gasPrice
     */

  }, {
    key: "signAccountFriendRecovery",
    value: function signAccountFriendRecovery(accountAddress, deviceAddress, gasPrice) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                return _context22.abrupt("return", this.accountFriendRecovery.signAccountFriendRecovery(accountAddress, deviceAddress, utils_1.anyToBN(gasPrice)));

              case 2:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
    }
    /**
     * cancels account friend recovery
     */

  }, {
    key: "cancelAccountFriendRecovery",
    value: function cancelAccountFriendRecovery() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                _context23.next = 3;
                return this.accountFriendRecovery.cancelAccountFriendRecovery();

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
    /**
     * submits account friend recovery
     */

  }, {
    key: "submitAccountFriendRecovery",
    value: function submitAccountFriendRecovery() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                return _context24.abrupt("return", this.accountFriendRecovery.submitAccountFriendRecovery().catch(function () {
                  return SdkError_1.SdkError.throwEthTransactionReverted();
                }));

              case 2:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    } // Account Device

    /**
     * gets connected account devices
     * @param page
     */

  }, {
    key: "getConnectedAccountDevices",
    value: function getConnectedAccountDevices() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context25.abrupt("return", this.apiMethods.getAccountDevices(accountAddress, page));

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));
    }
    /**
     * gets connected account devices
     * @param deviceAddress
     */

  }, {
    key: "getConnectedAccountDevice",
    value: function getConnectedAccountDevice(deviceAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context26.abrupt("return", this.apiMethods.getAccountDevice(accountAddress, deviceAddress));

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
    }
    /**
     * gets account device
     * @param accountAddress
     * @param deviceAddress
     */

  }, {
    key: "getAccountDevice",
    value: function getAccountDevice() {
      var accountAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var deviceAddress = arguments.length > 1 ? arguments[1] : undefined;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                return _context27.abrupt("return", this.apiMethods.getAccountDevice(accountAddress, deviceAddress));

              case 2:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
    }
    /**
     * creates account device
     * @param deviceAddress
     */

  }, {
    key: "createAccountDevice",
    value: function createAccountDevice(deviceAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true
                });

                accountAddress = this.state.accountAddress;
                return _context28.abrupt("return", this.apiMethods.createAccountDevice(accountAddress, deviceAddress, constants_1.AccountDeviceTypes.Owner));

              case 3:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
    }
    /**
     * removes account device
     * @param deviceAddress
     */

  }, {
    key: "removeAccountDevice",
    value: function removeAccountDevice(deviceAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true
                });

                accountAddress = this.state.accountAddress;
                return _context29.abrupt("return", this.apiMethods.removeAccountDevice(accountAddress, deviceAddress));

              case 3:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));
    }
    /**
     * estimates account device deployment
     * @param deviceAddress
     * @param gasPriceStrategy
     */

  }, {
    key: "estimateAccountDeviceDeployment",
    value: function estimateAccountDeviceDeployment(deviceAddress) {
      var gasPriceStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants_1.GasPriceStrategies.Avg;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var accountAddress, account, data;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                accountAddress = this.state.accountAddress;
                account = this.contract.account;
                data = account.encodeMethodInput('addDevice', deviceAddress, true);
                return _context30.abrupt("return", this.apiMethods.estimateAccountProxyTransaction(accountAddress, data, gasPriceStrategy));

              case 5:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
    }
    /**
     * estimates account device un-deployment
     * @param deviceAddress
     * @param gasPriceStrategy
     */

  }, {
    key: "estimateAccountDeviceUnDeployment",
    value: function estimateAccountDeviceUnDeployment(deviceAddress) {
      var gasPriceStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants_1.GasPriceStrategies.Avg;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        var accountAddress, account, data;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                accountAddress = this.state.accountAddress;
                account = this.contract.account;
                data = account.encodeMethodInput('removeDevice', deviceAddress);
                return _context31.abrupt("return", this.apiMethods.estimateAccountProxyTransaction(accountAddress, data, gasPriceStrategy));

              case 5:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));
    } // Account Transaction

    /**
     * gets connected account transactions
     * @param hash
     * @param page
     */

  }, {
    key: "getConnectedAccountTransactions",
    value: function getConnectedAccountTransactions() {
      var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context32.abrupt("return", this.apiMethods.getAccountTransactions(accountAddress, page, hash));

              case 3:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));
    }
    /**
     * gets connected account transaction
     * @param hash
     * @param index
     */

  }, {
    key: "getConnectedAccountTransaction",
    value: function getConnectedAccountTransaction(hash) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                this.require({
                  accountConnected: true
                });

                accountAddress = this.state.accountAddress;
                return _context33.abrupt("return", this.apiMethods.getAccountTransaction(accountAddress, hash, index));

              case 3:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));
    }
    /**
     * gets account transaction
     * @param accountAddress
     * @param hash
     * @param index
     */

  }, {
    key: "getAccountTransaction",
    value: function getAccountTransaction(accountAddress, hash) {
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                return _context34.abrupt("return", this.apiMethods.getAccountTransaction(accountAddress, hash, index));

              case 2:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
    }
  }, {
    key: "estimateAccountTransaction",
    value: function estimateAccountTransaction() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
        var accountAddress, account, proxyData, gasPriceStrategy, addToProxyData;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                accountAddress = this.state.accountAddress;
                account = this.contract.account;
                proxyData = [];
                gasPriceStrategy = constants_1.GasPriceStrategies.Avg;

                addToProxyData = function addToProxyData(index) {
                  var recipient = args[index * 3];
                  var value = args[index * 3 + 1];
                  var data = args[index * 3 + 2];
                  proxyData.push(account.encodeMethodInput('executeTransaction', recipient, utils_1.anyToBN(value, {
                    defaults: new bn_js_1.default(0)
                  }), utils_1.anyToBuffer(data, {
                    defaults: Buffer.alloc(0)
                  })));
                };

                _context35.t0 = args.length;
                _context35.next = _context35.t0 === 3 ? 9 : _context35.t0 === 4 ? 9 : _context35.t0 === 6 ? 12 : _context35.t0 === 7 ? 12 : _context35.t0 === 9 ? 16 : _context35.t0 === 10 ? 16 : _context35.t0 === 12 ? 21 : _context35.t0 === 13 ? 21 : _context35.t0 === 15 ? 27 : _context35.t0 === 16 ? 27 : 34;
                break;

              case 9:
                addToProxyData(0);
                gasPriceStrategy = args[3] || constants_1.GasPriceStrategies.Avg;
                return _context35.abrupt("break", 35);

              case 12:
                addToProxyData(0);
                addToProxyData(1);
                gasPriceStrategy = args[6] || constants_1.GasPriceStrategies.Avg;
                return _context35.abrupt("break", 35);

              case 16:
                addToProxyData(0);
                addToProxyData(1);
                addToProxyData(2);
                gasPriceStrategy = args[9] || constants_1.GasPriceStrategies.Avg;
                return _context35.abrupt("break", 35);

              case 21:
                addToProxyData(0);
                addToProxyData(1);
                addToProxyData(2);
                addToProxyData(3);
                gasPriceStrategy = args[12] || constants_1.GasPriceStrategies.Avg;
                return _context35.abrupt("break", 35);

              case 27:
                addToProxyData(0);
                addToProxyData(1);
                addToProxyData(2);
                addToProxyData(3);
                addToProxyData(4);
                gasPriceStrategy = args[15] || constants_1.GasPriceStrategies.Avg;
                return _context35.abrupt("break", 35);

              case 34:
                throw errors_1.ERR_WRONG_NUMBER_OF_ARGUMENTS;

              case 35:
                return _context35.abrupt("return", this.apiMethods.estimateAccountProxyTransaction(accountAddress, proxyData, gasPriceStrategy));

              case 36:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));
    }
    /**
     * submits account transaction
     * @param estimated
     */

  }, {
    key: "submitAccountTransaction",
    value: function submitAccountTransaction(estimated) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                return _context36.abrupt("return", this.accountTransaction.submitAccountProxyTransaction(estimated).catch(function () {
                  return SdkError_1.SdkError.throwEthTransactionReverted(estimated.data);
                }));

              case 2:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));
    } // Account Payment

    /**
     * gets connected account payments
     * @param page
     * @param filters
     */

  }, {
    key: "getConnectedAccountPayments",
    value: function getConnectedAccountPayments() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context37.abrupt("return", this.apiMethods.getAccountPayments(accountAddress, page, filters.state || ''));

              case 3:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));
    }
    /**
     * get connected account payment
     * @param hash
     */

  }, {
    key: "getConnectedAccountPayment",
    value: function getConnectedAccountPayment(hash) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context38.abrupt("return", this.apiMethods.getAccountPayment(accountAddress, hash));

              case 3:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));
    }
    /**
     * creates account payment
     * @param recipient
     * @param tokenAddress
     * @param value
     */

  }, {
    key: "createAccountPayment",
    value: function createAccountPayment(recipient, tokenAddress, value) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: !!recipient
                });

                return _context39.abrupt("return", this.accountPayment.createAccountPayment(recipient, tokenAddress, value));

              case 2:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));
    }
    /**
     * signs account payment
     * @param hash
     */

  }, {
    key: "signAccountPayment",
    value: function signAccountPayment(hash) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
        var accountAddress, payment;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                accountAddress = this.state.accountAddress;
                _context40.next = 4;
                return this.apiMethods.getAccountPayment(accountAddress, hash);

              case 4:
                payment = _context40.sent;
                return _context40.abrupt("return", this.accountPayment.signAccountPayment(payment));

              case 6:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));
    }
    /**
     * grab account payment
     * @param hash
     * @param recipient
     */

  }, {
    key: "grabAccountPayment",
    value: function grabAccountPayment(hash) {
      var recipient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context41.abrupt("return", this.apiMethods.grabAccountPayment(accountAddress, hash, recipient));

              case 3:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));
    }
    /**
     * cancel account payment
     * @param hash
     */

  }, {
    key: "cancelAccountPayment",
    value: function cancelAccountPayment(hash) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true
                });

                accountAddress = this.state.accountAddress;
                return _context42.abrupt("return", this.apiMethods.cancelAccountPayment(accountAddress, hash));

              case 3:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));
    }
    /**
     * estimates deposit account payment
     * @param hash
     * @param gasPriceStrategy
     */

  }, {
    key: "estimateDepositAccountPayment",
    value: function estimateDepositAccountPayment(hash) {
      var gasPriceStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants_1.GasPriceStrategies.Avg;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
        var hashes, args, virtualPaymentManager, _iterator, _step, _hash, accountAddress, _yield$this$apiMethod, sender, recipient, guardian, token, value, data;

        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                hashes = Array.isArray(hash) ? hash : [hash];
                args = [];
                virtualPaymentManager = this.contract.virtualPaymentManager;
                _iterator = _createForOfIteratorHelper(hashes);
                _context43.prev = 5;

                _iterator.s();

              case 7:
                if ((_step = _iterator.n()).done) {
                  _context43.next = 24;
                  break;
                }

                _hash = _step.value;
                accountAddress = this.state.accountAddress;
                _context43.next = 12;
                return this.apiMethods.getAccountPayment(accountAddress, _hash);

              case 12:
                _yield$this$apiMethod = _context43.sent;
                sender = _yield$this$apiMethod.sender;
                recipient = _yield$this$apiMethod.recipient;
                guardian = _yield$this$apiMethod.guardian;
                token = _yield$this$apiMethod.token;
                value = _yield$this$apiMethod.value;
                data = virtualPaymentManager.encodeMethodInput('depositPayment', sender.account.address, recipient.address || recipient.account.address, token && token.address ? token.address : utils_1.ZERO_ADDRESS, _hash, value, sender.signature, guardian.signature);
                args.push(virtualPaymentManager.address);
                args.push(null);
                args.push(data);

              case 22:
                _context43.next = 7;
                break;

              case 24:
                _context43.next = 29;
                break;

              case 26:
                _context43.prev = 26;
                _context43.t0 = _context43["catch"](5);

                _iterator.e(_context43.t0);

              case 29:
                _context43.prev = 29;

                _iterator.f();

                return _context43.finish(29);

              case 32:
                return _context43.abrupt("return", this.estimateAccountTransaction.apply(this, args.concat([gasPriceStrategy])));

              case 33:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this, [[5, 26, 29, 32]]);
      }));
    }
    /**
     * estimate withdraw account payment
     * @param hash
     * @param gasPriceStrategy
     */

  }, {
    key: "estimateWithdrawAccountPayment",
    value: function estimateWithdrawAccountPayment(hash) {
      var gasPriceStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants_1.GasPriceStrategies.Avg;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
        var hashes, args, virtualPaymentManager, _iterator2, _step2, _hash2, accountAddress, _yield$this$apiMethod2, sender, recipient, guardian, token, value, data;

        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                hashes = Array.isArray(hash) ? hash : [hash];
                args = [];
                virtualPaymentManager = this.contract.virtualPaymentManager;
                _iterator2 = _createForOfIteratorHelper(hashes);
                _context44.prev = 5;

                _iterator2.s();

              case 7:
                if ((_step2 = _iterator2.n()).done) {
                  _context44.next = 24;
                  break;
                }

                _hash2 = _step2.value;
                accountAddress = this.state.accountAddress;
                _context44.next = 12;
                return this.apiMethods.getAccountPayment(accountAddress, _hash2);

              case 12:
                _yield$this$apiMethod2 = _context44.sent;
                sender = _yield$this$apiMethod2.sender;
                recipient = _yield$this$apiMethod2.recipient;
                guardian = _yield$this$apiMethod2.guardian;
                token = _yield$this$apiMethod2.token;
                value = _yield$this$apiMethod2.value;
                data = virtualPaymentManager.encodeMethodInput('withdrawPayment', sender.account.address, recipient.address || recipient.account.address, token && token.address ? token.address : utils_1.ZERO_ADDRESS, _hash2, value, sender.signature, guardian.signature);
                args.push(virtualPaymentManager.address);
                args.push(null);
                args.push(data);

              case 22:
                _context44.next = 7;
                break;

              case 24:
                _context44.next = 29;
                break;

              case 26:
                _context44.prev = 26;
                _context44.t0 = _context44["catch"](5);

                _iterator2.e(_context44.t0);

              case 29:
                _context44.prev = 29;

                _iterator2.f();

                return _context44.finish(29);

              case 32:
                return _context44.abrupt("return", this.estimateAccountTransaction.apply(this, args.concat([gasPriceStrategy])));

              case 33:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this, [[5, 26, 29, 32]]);
      }));
    } // Account Game

    /**
     * gets connected account games
     * @param appAlias
     * @param page
     */

  }, {
    key: "getConnectedAccountGames",
    value: function getConnectedAccountGames(appAlias) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context45.abrupt("return", this.apiMethods.getAccountGames(accountAddress, appAlias, page));

              case 3:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));
    }
    /**
     * gets account game
     * @param gameId
     */

  }, {
    key: "getAccountGame",
    value: function getAccountGame(gameId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                return _context46.abrupt("return", this.apiMethods.getAccountGame(accountAddress, gameId));

              case 3:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));
    }
    /**
     * create account game
     * @param appAlias
     * @param deposit
     * @param data
     */

  }, {
    key: "createAccountGame",
    value: function createAccountGame(appAlias, deposit, data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
        var accountAddress;
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true
                });

                accountAddress = this.state.accountAddress;
                return _context47.abrupt("return", this.apiMethods.createAccountGame(accountAddress, appAlias, deposit, data));

              case 3:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));
    }
    /**
     * joins account game
     * @param gameId
     */

  }, {
    key: "joinAccountGame",
    value: function joinAccountGame(gameId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
        var accountAddress, game;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                accountAddress = this.state.accountAddress;
                _context48.next = 4;
                return this.apiMethods.getAccountGame(accountAddress, gameId);

              case 4:
                game = _context48.sent;

                if (!(game.creator.account.address === accountAddress)) {
                  _context48.next = 7;
                  break;
                }

                throw errors_1.ERR_INVALID_GAME_CREATOR;

              case 7:
                if (!(game.state !== constants_1.AccountGameStates.Open)) {
                  _context48.next = 9;
                  break;
                }

                throw errors_1.ERR_INVALID_GAME_STATE;

              case 9:
                return _context48.abrupt("return", this.accountGame.joinAccountGame(game));

              case 10:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));
    }
    /**
     * cancel account game
     * @param gameId
     */

  }, {
    key: "cancelAccountGame",
    value: function cancelAccountGame(gameId) {
      this.require({
        accountDeviceOwner: true
      });

      var accountAddress = this.state.accountAddress;
      return this.apiMethods.cancelAccountGame(accountAddress, gameId);
    }
    /**
     * starts account game
     * @param gameId
     */

  }, {
    key: "startAccountGame",
    value: function startAccountGame(gameId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
        var accountAddress, game;
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true,
                  accountDeviceDeployed: true
                });

                accountAddress = this.state.accountAddress;
                _context49.next = 4;
                return this.apiMethods.getAccountGame(accountAddress, gameId);

              case 4:
                game = _context49.sent;

                if (!(game.creator.account.address !== accountAddress)) {
                  _context49.next = 7;
                  break;
                }

                throw errors_1.ERR_INVALID_GAME_CREATOR;

              case 7:
                if (!(game.state !== constants_1.AccountGameStates.Opened)) {
                  _context49.next = 9;
                  break;
                }

                throw errors_1.ERR_INVALID_GAME_STATE;

              case 9:
                return _context49.abrupt("return", this.accountGame.startAccountGame(game));

              case 10:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));
    }
    /**
     * updates account game
     * @param gameId
     * @param data
     */

  }, {
    key: "updateAccountGame",
    value: function updateAccountGame(gameId, data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee50() {
        var accountAddress, game;
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                this.require();

                accountAddress = this.state.accountAddress;
                _context50.next = 4;
                return this.apiMethods.getAccountGame(accountAddress, gameId);

              case 4:
                game = _context50.sent;

                if (!(game.state !== constants_1.AccountGameStates.Started || game.whoseTurn === constants_1.AccountGamePlayers.Creator && game.creator.account.address !== accountAddress || game.whoseTurn === constants_1.AccountGamePlayers.Opponent && game.opponent.account.address !== accountAddress)) {
                  _context50.next = 7;
                  break;
                }

                throw errors_1.ERR_INVALID_GAME_STATE;

              case 7:
                return _context50.abrupt("return", this.apiMethods.updateAccountGame(accountAddress, game.id, data));

              case 8:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));
    } // App

    /**
     * gets apps
     * @param page
     */

  }, {
    key: "getApps",
    value: function getApps() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                return _context51.abrupt("return", this.apiMethods.getApps(page));

              case 2:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));
    }
    /**
     * gets app
     * @param appAlias
     */

  }, {
    key: "getApp",
    value: function getApp(appAlias) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                return _context52.abrupt("return", this.apiMethods.getApp(appAlias));

              case 2:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));
    }
    /**
     * gets app open games
     * @param appAlias
     * @param page
     */

  }, {
    key: "getAppOpenGames",
    value: function getAppOpenGames(appAlias) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                return _context53.abrupt("return", this.apiMethods.getAppOpenGames(appAlias, page));

              case 2:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));
    } // Token

    /**
     * gets tokens
     * @param page
     */

  }, {
    key: "getTokens",
    value: function getTokens() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                return _context54.abrupt("return", this.apiMethods.getTokens(page));

              case 2:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));
    }
    /**
     * gets token
     * @param symbolOrAddress
     */

  }, {
    key: "getToken",
    value: function getToken(symbolOrAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee55() {
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                this.require({
                  accountConnected: null
                });

                return _context55.abrupt("return", this.apiMethods.getToken(symbolOrAddress));

              case 2:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));
    }
    /**
     * gets token balance of
     * @param symbolOrAddress
     */

  }, {
    key: "getTokenBalance",
    value: function getTokenBalance(symbolOrAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
        var result, tokenAddress, token, accountAddress, output;
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                this.require({});

                result = null;
                tokenAddress = null;

                if (!utils_1.verifyAddress(symbolOrAddress, false)) {
                  _context56.next = 7;
                  break;
                }

                tokenAddress = symbolOrAddress;
                _context56.next = 11;
                break;

              case 7:
                _context56.next = 9;
                return this.apiMethods.getToken(symbolOrAddress).catch(function () {
                  return null;
                });

              case 9:
                token = _context56.sent;

                if (token && token.address) {
                  tokenAddress = token.address;
                }

              case 11:
                if (!tokenAddress) {
                  _context56.next = 17;
                  break;
                }

                accountAddress = this.state.accountAddress;
                _context56.next = 15;
                return this.contract.erc20Token.at(tokenAddress).callMethod('balanceOf', accountAddress).catch(function () {
                  return null;
                });

              case 15:
                output = _context56.sent;

                if (output && output['0'] && bn_js_1.default.isBN(output['0'])) {
                  result = output['0'];
                }

              case 17:
                return _context56.abrupt("return", result);

              case 18:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));
    } // Action

    /**
     * accepts incoming action
     * @param action
     */

  }, {
    key: "acceptIncomingAction",
    value: function acceptIncomingAction() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.require({
        accountConnected: null
      });

      this.action.acceptAction(action);
      return this;
    }
    /**
     * dismisses incoming action
     */

  }, {
    key: "dismissIncomingAction",
    value: function dismissIncomingAction() {
      this.require({
        accountConnected: null
      });

      this.action.dismissAction();
    } // Url

    /**
     * processes incoming url
     * @param url
     */

  }, {
    key: "processIncomingUrl",
    value: function processIncomingUrl(url) {
      this.require({
        accountConnected: null
      });

      this.url.incoming$.next(url);
    }
    /**
     * creates request add account device url
     * @param options
     */

  }, {
    key: "createRequestAddAccountDeviceUrl",
    value: function createRequestAddAccountDeviceUrl() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.require({
        accountConnected: false
      });

      var deviceAddress = this.state.deviceAddress;
      var action = modules_1.Action.createAction(modules_1.Action.Types.RequestAddAccountDevice, {
        device: deviceAddress,
        account: options.account || null,
        callbackEndpoint: options.callbackEndpoint || null
      });
      return this.url.buildActionUrl(action, options.endpoint || null);
    }
    /**
     * creates request sign secure code url
     */

  }, {
    key: "createRequestSignSecureCodeUrl",
    value: function createRequestSignSecureCodeUrl() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee57() {
        var deviceAddress, code, action;
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                this.require({
                  accountDeviceOwner: true
                });

                deviceAddress = this.state.deviceAddress;
                _context57.next = 4;
                return this.session.createCode();

              case 4:
                code = _context57.sent;
                action = modules_1.Action.createAction(modules_1.Action.Types.RequestSignSecureCode, {
                  code: code,
                  creator: deviceAddress
                });
                return _context57.abrupt("return", this.url.buildActionUrl(action));

              case 7:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));
    } // Utils

    /**
     * signs personal message
     * @param message
     */

  }, {
    key: "signPersonalMessage",
    value: function signPersonalMessage(message) {
      this.require({
        accountConnected: null
      });

      return this.device.signPersonalMessage(message);
    }
    /**
     * recovers account device from personal message signature
     * @param accountAddress
     * @param message
     * @param signature
     */

  }, {
    key: "recoverAccountDeviceFromPersonalMessageSignature",
    value: function recoverAccountDeviceFromPersonalMessageSignature(accountAddress, message, signature) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee58() {
        var result, deviceAddress;
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                result = null;
                _context58.prev = 1;
                deviceAddress = utils_1.recoverAddressFromPersonalMessage(message, signature);

                if (!deviceAddress) {
                  _context58.next = 7;
                  break;
                }

                _context58.next = 6;
                return this.apiMethods.getAccountDevice(accountAddress, deviceAddress);

              case 6:
                result = _context58.sent;

              case 7:
                _context58.next = 12;
                break;

              case 9:
                _context58.prev = 9;
                _context58.t0 = _context58["catch"](1);
                result = null;

              case 12:
                return _context58.abrupt("return", result);

              case 13:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this, [[1, 9]]);
      }));
    }
    /**
     * gets transaction details
     * @param hash
     */

  }, {
    key: "getTransactionDetails",
    value: function getTransactionDetails(hash) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
        var result, tx;
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                result = null;
                _context59.next = 3;
                return this.eth.getTransactionByHash(hash).catch(function () {
                  return null;
                });

              case 3:
                tx = _context59.sent;

                if (!tx) {
                  _context59.next = 13;
                  break;
                }

                _context59.t0 = Object;
                _context59.t1 = {};
                _context59.t2 = tx;
                _context59.next = 10;
                return this.eth.getTransactionReceipt(hash).catch(function () {
                  return null;
                });

              case 10:
                _context59.t3 = _context59.sent;
                _context59.t4 = {
                  receipt: _context59.t3
                };
                result = _context59.t0.assign.call(_context59.t0, _context59.t1, _context59.t2, _context59.t4);

              case 13:
                return _context59.abrupt("return", result);

              case 14:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));
    }
    /**
     * creates contract instance
     * @param abi
     * @param address
     */

  }, {
    key: "createContractInstance",
    value: function createContractInstance(abi) {
      var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.contract.createInstance(abi, address);
    } // Protected

  }, {
    key: "setEnvironment",
    value: function setEnvironment(environment) {
      this.storage = new modules_1.Storage(environment.getConfig('storageOptions'), environment.getConfig('storageAdapter'));
      this.api = new modules_1.Api(environment.getConfig('apiOptions'), environment.getConfig('apiWebSocketConstructor'), this.state);
      this.apiMethods = new modules_1.ApiMethods(this.api);
      this.device = new modules_1.Device(this.state, this.storage.createChild(Sdk.StorageNamespaces.Device));
      this.session = new modules_1.Session(this.api, this.device, this.state);
      this.eth = new modules_1.Eth(environment.getConfig('ethOptions'), this.api, this.state);
      this.ens = new modules_1.Ens(environment.getConfig('ensOptions'), this.eth, this.state);
      this.contract = new modules_1.Contract(this.eth);
      this.action = new modules_1.Action(environment.getConfig('actionOptions'));
      this.url = new modules_1.Url(environment.getConfig('urlOptions'), environment.getConfig('urlAdapter'), this.action, this.eth);
      this.accountTransaction = new modules_1.AccountTransaction(this.apiMethods, this.contract, this.device, this.state);
      this.accountPayment = new modules_1.AccountPayment(this.apiMethods, this.contract, this.device, this.state);
      this.accountGame = new modules_1.AccountGame(this.apiMethods, this.contract, this.device, this.state);
      this.accountFriendRecovery = new modules_1.AccountFriendRecovery(this.apiMethods, this.contract, this.device, this.state);
    }
  }, {
    key: "addSubscriptions",
    value: function addSubscriptions() {
      for (var _len2 = arguments.length, subscriptions = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        subscriptions[_key2] = arguments[_key2];
      }

      this.subscriptions = [].concat(_toConsumableArray(this.subscriptions || []), _toConsumableArray(subscriptions.filter(function (subscription) {
        return !!subscription;
      })));
    }
  }, {
    key: "removeSubscriptions",
    value: function removeSubscriptions(subscription) {
      if (subscription && this.subscriptions && this.subscriptions.includes(subscription)) {
        subscription.unsubscribe();
        this.subscriptions = this.subscriptions.filter(function (item) {
          return item !== subscription;
        });

        if (!this.subscriptions.length) {
          this.subscriptions = null;
        }
      }

      return null;
    }
  }, {
    key: "clearSubscriptions",
    value: function clearSubscriptions() {
      if (this.subscriptions) {
        var _iterator3 = _createForOfIteratorHelper(this.subscriptions),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var subscription = _step3.value;
            subscription.unsubscribe();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        this.subscriptions = null;
      }
    }
  }, {
    key: "prepareAccount",
    value: function prepareAccount(account) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee60() {
        var balance;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.prev = 0;
                _context60.next = 3;
                return this.eth.getBalance(account.address, 'pending');

              case 3:
                balance = _context60.sent;

                if (balance) {
                  account.balance.real = balance;
                }

                _context60.next = 9;
                break;

              case 7:
                _context60.prev = 7;
                _context60.t0 = _context60["catch"](0);

              case 9:
                return _context60.abrupt("return", account);

              case 10:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this, [[0, 7]]);
      }));
    }
  }, {
    key: "verifyAccount",
    value: function verifyAccount() {
      var accountAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee61() {
        var _this$state4, account$, accountDevice$, deviceAddress, account, accountDevice;

        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                if (!accountAddress) {
                  accountAddress = this.state.accountAddress;
                }

                _this$state4 = this.state, account$ = _this$state4.account$, accountDevice$ = _this$state4.accountDevice$, deviceAddress = _this$state4.deviceAddress;
                account = null;
                accountDevice = null;

                if (!accountAddress) {
                  _context61.next = 15;
                  break;
                }

                _context61.next = 7;
                return this.apiMethods.getAccount(accountAddress).catch(function () {
                  return null;
                });

              case 7:
                account = _context61.sent;

                if (!account) {
                  _context61.next = 15;
                  break;
                }

                _context61.next = 11;
                return this.prepareAccount(account);

              case 11:
                account = _context61.sent;
                _context61.next = 14;
                return this.apiMethods.getAccountDevice(accountAddress, deviceAddress).catch(function () {
                  return null;
                });

              case 14:
                accountDevice = _context61.sent;

              case 15:
                account$.next(account && accountDevice ? account : null);
                accountDevice$.next(accountDevice);

              case 17:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));
    }
  }, {
    key: "subscribeAccountBalance",
    value: function subscribeAccountBalance() {
      var _this = this;

      var account$ = this.state.account$;
      var subscription = null;
      account$.subscribe(function (account) {
        if (account) {
          if (!subscription) {
            subscription = rxjs_1.timer(5000, 5000).pipe(operators_1.switchMap(function () {
              return rxjs_1.from(_this.eth.getBalance(account.address, 'pending').catch(function () {
                return null;
              }));
            }), operators_1.filter(function (balance) {
              return !!balance;
            }), operators_1.map(function (real) {
              var account = _this.state.account;
              return Object.assign({}, account, {
                balance: {
                  real: real,
                  virtual: account.balance.virtual
                }
              });
            }), operators_1.filter(function (account) {
              return !!account;
            })).subscribe(account$);

            _this.addSubscriptions(subscription);
          }
        } else if (subscription) {
          _this.removeSubscriptions(subscription);

          subscription = null;
        }
      });
    }
  }, {
    key: "subscribeApiEvents",
    value: function subscribeApiEvents() {
      var _this2 = this;

      var event$ = this.api.event$;
      this.addSubscriptions({
        closed: false,
        unsubscribe: function unsubscribe() {
          event$.complete();
        }
      }, event$.pipe(operators_1.filter(function (event) {
        return !!event;
      }), operators_1.switchMap(function (_ref2) {
        var name = _ref2.name,
            payload = _ref2.payload;
        return rxjs_1.from(_this2.wrapAsync(function () {
          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
            var _this$state5, account$, accountDevice$, deviceAddress, accountAddress, _account, _account2, _account3, _account4, accountFriendRecovery, _account5, device, accountDevice, _accountDevice, _account6, _device, _account7, token, accountVirtualBalance, _account8, hash, index, accountTransaction, _account9, game, accountGame, _account10, _hash3, accountPayment, _device2, code, action;

            return _regeneratorRuntime.wrap(function _callee62$(_context62) {
              while (1) {
                switch (_context62.prev = _context62.next) {
                  case 0:
                    _this$state5 = this.state, account$ = _this$state5.account$, accountDevice$ = _this$state5.accountDevice$, deviceAddress = _this$state5.deviceAddress, accountAddress = _this$state5.accountAddress;
                    _context62.t0 = name;
                    _context62.next = _context62.t0 === modules_1.Api.EventNames.AccountUpdated ? 4 : _context62.t0 === modules_1.Api.EventNames.AccountFriendRecoveryUpdated ? 17 : _context62.t0 === modules_1.Api.EventNames.AccountDeviceUpdated ? 24 : _context62.t0 === modules_1.Api.EventNames.AccountDeviceRemoved ? 45 : _context62.t0 === modules_1.Api.EventNames.AccountVirtualBalanceUpdated ? 54 : _context62.t0 === modules_1.Api.EventNames.AccountTransactionUpdated ? 61 : _context62.t0 === modules_1.Api.EventNames.AccountGameUpdated ? 68 : _context62.t0 === modules_1.Api.EventNames.AccountPaymentUpdated ? 75 : _context62.t0 === modules_1.Api.EventNames.SecureCodeSigned ? 82 : 85;
                    break;

                  case 4:
                    _account = payload.account;

                    if (!(accountAddress === _account)) {
                      _context62.next = 12;
                      break;
                    }

                    _context62.next = 8;
                    return this.apiMethods.getAccount(accountAddress);

                  case 8:
                    _account2 = _context62.sent;

                    if (_account2) {
                      account$.next(_account2);
                    }

                    _context62.next = 16;
                    break;

                  case 12:
                    _context62.next = 14;
                    return this.apiMethods.getAccount(accountAddress);

                  case 14:
                    _account3 = _context62.sent;
                    this.emitEvent(Sdk.EventNames.AccountUpdated, _account3);

                  case 16:
                    return _context62.abrupt("break", 85);

                  case 17:
                    _account4 = payload.account;

                    if (!(accountAddress === _account4)) {
                      _context62.next = 23;
                      break;
                    }

                    _context62.next = 21;
                    return this.apiMethods.getAccountFriendRecovery(accountAddress);

                  case 21:
                    accountFriendRecovery = _context62.sent;
                    this.emitEvent(Sdk.EventNames.AccountFriendRecoveryUpdated, accountFriendRecovery);

                  case 23:
                    return _context62.abrupt("break", 85);

                  case 24:
                    _account5 = payload.account, device = payload.device;

                    if (!(deviceAddress === device)) {
                      _context62.next = 39;
                      break;
                    }

                    _context62.t1 = accountAddress;
                    _context62.next = _context62.t1 === _account5 ? 29 : _context62.t1 === null ? 34 : 37;
                    break;

                  case 29:
                    _context62.next = 31;
                    return this.apiMethods.getAccountDevice(_account5, device);

                  case 31:
                    accountDevice = _context62.sent;

                    if (accountDevice) {
                      accountDevice$.next(accountDevice);
                    }

                    return _context62.abrupt("break", 37);

                  case 34:
                    _context62.next = 36;
                    return this.verifyAccount(_account5);

                  case 36:
                    return _context62.abrupt("break", 37);

                  case 37:
                    _context62.next = 44;
                    break;

                  case 39:
                    if (!(_account5 === accountAddress)) {
                      _context62.next = 44;
                      break;
                    }

                    _context62.next = 42;
                    return this.apiMethods.getAccountDevice(accountAddress, device);

                  case 42:
                    _accountDevice = _context62.sent;
                    this.emitEvent(Sdk.EventNames.AccountDeviceUpdated, _accountDevice);

                  case 44:
                    return _context62.abrupt("break", 85);

                  case 45:
                    _account6 = payload.account, _device = payload.device;

                    if (!(accountAddress === _account6)) {
                      _context62.next = 53;
                      break;
                    }

                    if (!(deviceAddress === _device)) {
                      _context62.next = 52;
                      break;
                    }

                    _context62.next = 50;
                    return this.reset();

                  case 50:
                    _context62.next = 53;
                    break;

                  case 52:
                    this.emitEvent(Sdk.EventNames.AccountDeviceRemoved, _device);

                  case 53:
                    return _context62.abrupt("break", 85);

                  case 54:
                    _account7 = payload.account, token = payload.token;

                    if (!(accountAddress === _account7)) {
                      _context62.next = 60;
                      break;
                    }

                    _context62.next = 58;
                    return this.apiMethods.getAccountVirtualBalance(accountAddress, token);

                  case 58:
                    accountVirtualBalance = _context62.sent;
                    this.emitEvent(Sdk.EventNames.AccountVirtualBalanceUpdated, accountVirtualBalance);

                  case 60:
                    return _context62.abrupt("break", 85);

                  case 61:
                    _account8 = payload.account, hash = payload.hash, index = payload.index;

                    if (!(accountAddress === _account8)) {
                      _context62.next = 67;
                      break;
                    }

                    _context62.next = 65;
                    return this.apiMethods.getAccountTransaction(accountAddress, hash, index);

                  case 65:
                    accountTransaction = _context62.sent;
                    this.emitEvent(Sdk.EventNames.AccountTransactionUpdated, accountTransaction);

                  case 67:
                    return _context62.abrupt("break", 85);

                  case 68:
                    _account9 = payload.account, game = payload.game;

                    if (!(accountAddress === _account9)) {
                      _context62.next = 74;
                      break;
                    }

                    _context62.next = 72;
                    return this.apiMethods.getAccountGame(accountAddress, game);

                  case 72:
                    accountGame = _context62.sent;
                    this.emitEvent(Sdk.EventNames.AccountGameUpdated, accountGame);

                  case 74:
                    return _context62.abrupt("break", 85);

                  case 75:
                    _account10 = payload.account, _hash3 = payload.hash;

                    if (!(accountAddress === _account10)) {
                      _context62.next = 81;
                      break;
                    }

                    _context62.next = 79;
                    return this.apiMethods.getAccountPayment(accountAddress, _hash3);

                  case 79:
                    accountPayment = _context62.sent;
                    this.emitEvent(Sdk.EventNames.AccountPaymentUpdated, accountPayment);

                  case 81:
                    return _context62.abrupt("break", 85);

                  case 82:
                    _device2 = payload.device, code = payload.code;

                    if (deviceAddress && accountAddress && this.session.verifyCode(code)) {
                      action = modules_1.Action.createAction(modules_1.Action.Types.RequestAddAccountDevice, {
                        device: _device2,
                        account: accountAddress
                      });
                      this.action.$incoming.next(action);
                    }

                    return _context62.abrupt("break", 85);

                  case 85:
                  case "end":
                    return _context62.stop();
                }
              }
            }, _callee62, this);
          }));
        }));
      })).subscribe());
    }
  }, {
    key: "subscribeAcceptedActions",
    value: function subscribeAcceptedActions() {
      var _this3 = this;

      var account$ = this.state.account$;
      var $accepted = this.action.$accepted;
      var hasAccount = null;
      var subscription = null;
      account$.subscribe(function (account) {
        if (hasAccount === !!account) {
          return;
        }

        hasAccount = !!account;

        _this3.removeSubscriptions(subscription);

        subscription = $accepted.pipe(operators_1.filter(function (action) {
          return !!action;
        }), operators_1.switchMap(function (_ref3) {
          var type = _ref3.type,
              payload = _ref3.payload;
          return rxjs_1.from(_this3.wrapAsync(function () {
            return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
              var accountAddress, device, _account11, callbackEndpoint, action, _account12, code, creator;

              return _regeneratorRuntime.wrap(function _callee63$(_context63) {
                while (1) {
                  switch (_context63.prev = _context63.next) {
                    case 0:
                      accountAddress = this.state.accountAddress;
                      _context63.t0 = type;
                      _context63.next = _context63.t0 === modules_1.Action.Types.RequestAddAccountDevice ? 4 : _context63.t0 === modules_1.Action.Types.AccountDeviceAdded ? 10 : _context63.t0 === modules_1.Action.Types.RequestSignSecureCode ? 15 : 20;
                      break;

                    case 4:
                      device = payload.device, _account11 = payload.account, callbackEndpoint = payload.callbackEndpoint;

                      if (!(accountAddress && device && (!_account11 || accountAddress === _account11))) {
                        _context63.next = 9;
                        break;
                      }

                      _context63.next = 8;
                      return this.createAccountDevice(device);

                    case 8:
                      if (callbackEndpoint) {
                        action = modules_1.Action.createAction(modules_1.Action.Types.AccountDeviceAdded, {
                          account: accountAddress
                        });
                        this.url.openActionUrl(action, callbackEndpoint);
                      }

                    case 9:
                      return _context63.abrupt("break", 20);

                    case 10:
                      if (accountAddress) {
                        _context63.next = 14;
                        break;
                      }

                      _account12 = payload.account;
                      _context63.next = 14;
                      return this.verifyAccount(_account12);

                    case 14:
                      return _context63.abrupt("break", 20);

                    case 15:
                      if (accountAddress) {
                        _context63.next = 19;
                        break;
                      }

                      code = payload.code, creator = payload.creator;
                      _context63.next = 19;
                      return this.session.signCode(creator, code);

                    case 19:
                      return _context63.abrupt("break", 20);

                    case 20:
                    case "end":
                      return _context63.stop();
                  }
                }
              }, _callee63, this);
            }));
          }));
        }), operators_1.map(function () {
          return null;
        })).subscribe($accepted);

        _this3.addSubscriptions(subscription);
      });
    }
  }, {
    key: "wrapAsync",
    value: function wrapAsync(wrapped) {
      var _this4 = this;

      return wrapped().catch(function (err) {
        _this4.catchError(err);

        return null;
      });
    }
  }, {
    key: "catchError",
    value: function catchError(err) {
      this.error$.next(SdkError_1.SdkError.fromAny(err));
    }
  }, {
    key: "emitEvent",
    value: function emitEvent(name, payload) {
      this.event$.next({
        name: name,
        payload: payload
      });
    }
  }, {
    key: "require",
    value: function require() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$state6 = this.state,
          account = _this$state6.account,
          accountDevice = _this$state6.accountDevice,
          initialized = _this$state6.initialized;
      options = Object.assign({
        initialized: true,
        accountConnected: true
      }, options);
      var accountState = account && !account.nextState ? account.state : null;
      var accountDeviceState = accountDevice && !accountDevice.nextState ? accountDevice.state : null;
      var accountDeviceType = accountDevice ? accountDevice.type : null;
      var accountRealBalance = account && account.balance && account.balance.real ? account.balance.real : new bn_js_1.default(0);
      var accountVirtualBalance = account && account.balance && account.balance.virtual ? account.balance.virtual : new bn_js_1.default(0);

      if (options.initialized === true && !initialized) {
        throw errors_1.ERR_SDK_NOT_INITIALIZED;
      }

      if (options.initialized === false && initialized) {
        throw errors_1.ERR_SDK_ALREADY_INITIALIZED;
      }

      if (options.accountConnected === true && !account) {
        throw errors_1.ERR_ACCOUNT_DISCONNECTED;
      }

      if (options.accountConnected === false && account) {
        throw errors_1.ERR_ACCOUNT_ALREADY_CONNECTED;
      }

      if (options.accountCreated && accountState !== constants_1.AccountStates.Created) {
        throw errors_1.ERR_INVALID_ACCOUNT_STATE;
      }

      if (options.accountDeployed && accountState !== constants_1.AccountStates.Deployed) {
        throw errors_1.ERR_INVALID_ACCOUNT_STATE;
      }

      if (options.accountDeviceCreated && accountDeviceState !== constants_1.AccountDeviceStates.Created) {
        throw errors_1.ERR_INVALID_ACCOUNT_DEVICE_STATE;
      }

      if (options.accountDeviceDeployed && accountDeviceState !== constants_1.AccountDeviceStates.Deployed) {
        throw errors_1.ERR_INVALID_ACCOUNT_DEVICE_STATE;
      }

      if (options.accountDeviceOwner && accountDeviceType !== constants_1.AccountDeviceTypes.Owner) {
        throw errors_1.ERR_INVALID_ACCOUNT_DEVICE_TYPE;
      }

      if (options.accountRealBalance && accountRealBalance.lt(options.accountRealBalance)) {
        throw errors_1.ERR_NOT_ENOUGH_REAL_FUNDS;
      }

      if (options.accountVirtualBalance && accountVirtualBalance.lt(options.accountRealBalance)) {
        throw errors_1.ERR_NOT_ENOUGH_VIRTUAL_FUNDS;
      }
    }
  }]);

  return Sdk;
}();

exports.Sdk = Sdk;

(function (Sdk) {
  var StorageNamespaces;

  (function (StorageNamespaces) {
    StorageNamespaces["Device"] = "device";
  })(StorageNamespaces = Sdk.StorageNamespaces || (Sdk.StorageNamespaces = {}));

  var EventNames;

  (function (EventNames) {
    EventNames["AccountUpdated"] = "AccountUpdated";
    EventNames["AccountDeviceUpdated"] = "AccountDeviceUpdated";
    EventNames["AccountDeviceRemoved"] = "AccountDeviceRemoved";
    EventNames["AccountFriendRecoveryUpdated"] = "AccountFriendRecoveryUpdated";
    EventNames["AccountTransactionUpdated"] = "AccountTransactionUpdated";
    EventNames["AccountVirtualBalanceUpdated"] = "AccountVirtualBalanceUpdated";
    EventNames["AccountPaymentUpdated"] = "AccountPaymentUpdated";
    EventNames["AccountGameUpdated"] = "AccountGameUpdated";
  })(EventNames = Sdk.EventNames || (Sdk.EventNames = {}));
})(Sdk = exports.Sdk || (exports.Sdk = {}));